import { useEffect, useRef } from 'react';
import { countDowntFactoryBoostTimers } from '@redux/reducers/factoryReducer';
import { countDowntQuarryBoostTimers } from '@redux/reducers/quarryReducer';
import { countDowntWorkshopBoostTimers } from '@redux/reducers/workshopReducer';
import { useAppDispatch } from '@redux/store';

import { type PlantType } from '../types/common';

const useCountDownBoostsTimers = (
  isTimersActive: boolean,
  kind: PlantType,
): void => {
  const timerId = useRef<NodeJS.Timeout | undefined>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isTimersActive) {
      timerId.current = setInterval(() => {
        if (kind === 'Quarry') {
          dispatch(countDowntQuarryBoostTimers());
        }

        if (kind === 'Factory') {
          dispatch(countDowntFactoryBoostTimers());
        }

        if (kind === 'Workshop') {
          dispatch(countDowntWorkshopBoostTimers());
        }
      }, 1000);
    }

    if (!isTimersActive) {
      clearInterval(timerId.current);
    }

    return (): void => {
      clearInterval(timerId.current);
    };
  }, [isTimersActive, kind]);
};

export { useCountDownBoostsTimers };
